import _ from 'lodash';
import { fromJS } from 'immutable';
import * as constants from '../activity.constants';
import {
  getDefaultPromoCodeBulksImportedType,
  getDefaultPromoCodeImportedCopyPasteType
} from './activity.reducer.defaults';

export function activityPromoCodeReducer(state, action) {
  if (state.getIn([constants.DATA, constants.TYPE]) !== constants.ACTIVITY_TYPE_PROMO_CODE) {
    return state;
  }
  switch (action.type) {

    case constants.UPDATE_PROMO_CODE_SINGLE_CODE_VALUE: {
      return state.setIn([
        constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE_SINGLE_CODE, action.bulkIndex, constants.PROMO_CODE_SINGLE_CODE_BULK_VALUE
      ], action.value)
        .setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], false);
    }
    case constants.UPDATE_PROMO_CODE_BULK_IS_AVAILABILITY: {
      if (!action.value) {
        state = state.setIn([constants.VALIDATION_ERRORS, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE_SINGLE_CODE, '0'],
          'activity.validation.error.promo.code.bulk.single.code.in.use');
      }
      return state.setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], !action.value);
    }
    case constants.UPDATE_PROMO_CODE_BULKS_VALUE: {
      return state.setIn([
        constants.DATA, constants.PROMO_CODE_BULKS
      ], action.value)
        .setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], false);
    }

    case constants.UPDATE_PROMO_CODE_BULKS_IMPORTED_VALUE: {
      return state.setIn([
        constants.DATA, constants.PROMO_CODE_BULKS
      ], action.value)
        .setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], false);
    }

    case constants.UPDATE_PROMO_CODES_IMPORTED: {
      let newState = state;
      if (action.mode) {
        newState = newState.set(constants.PROMO_CODE_IMPORTED_MODE, action.mode);
      }
      if (action.value) {
        const promoCodesImportedArray = transformCsvOrExcelDataToArray(action.value);
        newState = newState.setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE,
          constants.IMPORT_PROMO_CODES_PASTING], false);
        newState = newState.setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE,
          constants.PROMO_CODE_BULK_INPUT_VALUE], fromJS(promoCodesImportedArray));
      }
      return newState;
    }

    case constants.CLEAR_IMPORTED_PROMO_CODES_COPY_PASTE: {
      return state
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE, constants.PROMO_CODE_BULK_INPUT_VALUE],
          null);
    }

    case constants.GOING_TO_PASTE_IMPORTED_PROMO_CODES_DATA: {
      return state.setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE,
        constants.IMPORT_PROMO_CODES_PASTING], true);
    }

    case constants.ADD_PROMO_CODE_BULK_IMPORTED: {
      const newBulk = action.value;
      return state.updateIn([constants.DATA, constants.PROMO_CODE_BULKS], (bulks) =>
        bulks.push(fromJS(newBulk))
      );
    }

    case constants.REMOVE_PROMO_CODE_BULK_IMPORTED: {
      const index = action.value;
      const newBulks = [...state.getIn([constants.DATA, constants.PROMO_CODE_BULKS])].filter((groupId, i) => i !== index);
      return state.setIn([constants.DATA, constants.PROMO_CODE_BULKS], fromJS(newBulks));
    }

    case constants.UPDATE_PROMO_CODE_BULK_IMPORTED_FIELD_VALUE: {
      const { fieldName, value, index } = action;
      const bulks = state.getIn([constants.DATA, constants.PROMO_CODE_BULKS]);
      const updatedBulks = fromJS(bulks).update(index, (bulk) => bulk.set(fieldName, value));
      return state.setIn([constants.DATA, constants.PROMO_CODE_BULKS], updatedBulks);
    }

    case constants.GET_FREE_PROMO_CODES_NUMBER_SUCCESS: {
      return state.setIn([constants.DATA, constants.FREE_PROMO_CODES_NUMBER], action.value);
    }

    case constants.SET_PROMO_CODE_IMPORTED_MODE: {
      return state.setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_MODE], action.value);
    }

    case constants.PROMO_CODES_IMPORTED_MODAL_OPEN: {
      return state
        .set(constants.PROMO_CODE_IMPORTED_MODE, constants.IMPORT_PROMO_CODES_COPY_PASTE_MODE)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD], fromJS(getDefaultPromoCodeBulksImportedType()))
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE], fromJS(getDefaultPromoCodeImportedCopyPasteType()))
        .setIn([constants.DATA, constants.IS_PROMO_CODE_IMPORTED_MODAL_OPEN], true)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_ACTIVE_INDEX], action.activeIndex);
    }

    case constants.RESET_PROMO_CODES_IMPORTED_MODAL: {
      return state
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD], fromJS(getDefaultPromoCodeBulksImportedType()))
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE], fromJS(getDefaultPromoCodeImportedCopyPasteType()))
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_MODE], null)
        .setIn([constants.DATA, constants.IS_PROMO_CODE_IMPORTED_MODAL_OPEN], false);
    }

    case constants.PROMO_CODE_IMPORTED_SET_UPLOAD_IN_PROGRESS: {
      const { inProgress } = action;
      return state.set(constants.PROMO_CODE_IMPORTED_FILE_UPLOAD_IN_PROGRESS, inProgress);
    }

    case constants.PROMO_CODE_IMPORTED_SAVE_BULK: {
      const { bulkIndex, mode, tempRelevantBulk } = action;
      let updatedBulks = state.getIn([constants.DATA, constants.PROMO_CODE_BULKS]);
      if (mode === constants.IMPORT_PROMO_CODES_UPLOAD_FILE_MODE) {
        const dataFile = tempRelevantBulk.get(constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE);
        const newBucketName = dataFile.get(constants.PROMO_CODE_FILE_UPLOADED_BULK_BUCKET_NAME);
        const newFileName = dataFile.get(constants.PROMO_CODE_FILE_UPLOADED_BULK_OBJECT_NAME);
        const newUrl = dataFile.get(constants.PROMO_CODE_FILE_UPLOADED_BULK_MEDIA_LINK);

        if (newFileName && newUrl) {
          updatedBulks = updatedBulks.update(bulkIndex, (bulk) => {
            let updatedBulk = bulk
              .setIn([constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_OBJECT_NAME], newFileName)
              .setIn([constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_MEDIA_LINK], newUrl);
            if (newBucketName) {
              updatedBulk = updatedBulk.setIn([constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_BUCKET_NAME], newBucketName);
            }
            return updatedBulk;
          });
        }
      } else if (mode === constants.IMPORT_PROMO_CODES_COPY_PASTE_MODE) {
        updatedBulks = updatedBulks.update(bulkIndex, (bulk) => tempRelevantBulk);
      }

      return state
        .setIn([constants.DATA, constants.IS_PROMO_CODE_IMPORTED_MODAL_OPEN], false)
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS], updatedBulks);
    }

    case constants.UPDATE_PROMO_CODE_BULK_TYPE: {
      return state.setIn([
        constants.DATA, constants.PROMO_CODE_BULKS_TYPE
      ], action.value)
        .setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], false);
    }

    case constants.IMPORT_CODES_BULK_UPLOAD: {
      return state.set(constants.PROMO_CODE_FILE_UPLOAD_IN_PROGRESS, true);
    }

    case constants.PROMO_CODES_IMPORTED_FILE_UPLOAD: {
      return state.set(constants.PROMO_CODE_IMPORTED_FILE_UPLOAD_IN_PROGRESS, true);
    }

    case constants.IMPORT_CODES_BULK_UPLOAD_SUCCESS: {
      return state
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE_FILE_UPLOADED, action.bulkIndex, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_FILE_NAME], action.objectName)
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE_FILE_UPLOADED, action.bulkIndex, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_BUCKET_NAME], action.bucketName)
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE_FILE_UPLOADED, action.bulkIndex, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_MEDIA_LINK], action.url)
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE], constants.PROMO_CODE_MODE_FILE_UPLOADED)
        .setIn([constants.PROMO_CODE_FILE_UPLOAD_IN_PROGRESS], false)
        .setIn([constants.DATA, constants.VALIDATION_PROMO_CODE_TAKEN_FLAG], false)
        .delete(constants.VALIDATION_ERRORS)
        .deleteIn([constants.DATA, constants.VALIDATION_PROMO_CODE_ERROR]);
    }

    case constants.PROMO_CODES_IMPORTED_FILE_UPLOAD_SUCCESS: {
      return state
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_OBJECT_NAME], action.objectName)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_BUCKET_NAME], action.bucketName)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_MEDIA_LINK], action.url)
        .deleteIn([constants.DATA, constants.VALIDATION_PROMO_CODE_ERROR])
        .set(constants.PROMO_CODE_IMPORTED_FILE_UPLOAD_IN_PROGRESS, false);
    }

    case constants.PROMO_CODES_IMPORTED_UPDATE_ORIGINAL_DATA_BULKS: {
      return state
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_OBJECT_NAME], action.objectName)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_BUCKET_NAME], action.bucketName)
        .setIn([constants.DATA, constants.PROMO_CODE_IMPORTED_TEMP_BULK, constants.PROMO_CODE_IMPORTED_TEMP_FILE_UPLOAD, constants.PROMO_CODE_FILE_UPLOADED_DATA_FILE, constants.PROMO_CODE_FILE_UPLOADED_BULK_MEDIA_LINK], action.url)
        .deleteIn([constants.DATA, constants.VALIDATION_PROMO_CODE_ERROR])
        .set(constants.PROMO_CODE_IMPORTED_FILE_UPLOAD_IN_PROGRESS, false);
    }

    case constants.PROMO_CODES_IMPORTED_FILE_UPLOAD_ERROR: {
      return state.setIn([constants.PROMO_CODE_IMPORTED_FILE_UPLOAD_IN_PROGRESS], false);
    }

    case constants.PROMO_CODES_GET_LOYALTY_FILES_URL_SUCCESS: {
      const loyaltyBulksUrls = action[constants.PROMO_CODE_BULKS_IMPORTED_LOYALTY_URLS];
      const newBulks = state.getIn([constants.DATA, constants.PROMO_CODE_BULKS]).toJS();

      newBulks.forEach((bulk) => {
        const loyaltyBulkUrl = loyaltyBulksUrls[bulk.key];
        if (loyaltyBulkUrl) {
          if (loyaltyBulkUrl.url) {
            bulk.dataFile.loyaltyUrl = loyaltyBulkUrl.url;
            bulk.dataFile.loyaltyObjectName = loyaltyBulkUrl.objectName;
            bulk.dataFile.loyaltyBucketName = loyaltyBulkUrl.bucketName;
          }
          if (loyaltyBulkUrl.size !== undefined) {
            bulk.size = Number(loyaltyBulkUrl.size); // converting size to number, since it's a string
          }
        }
      });

      const immutableCodeBulks = fromJS(newBulks);

      return state
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS], immutableCodeBulks)
        .setIn([constants.ORIGINAL_DATA, constants.PROMO_CODE_BULKS], immutableCodeBulks);
    }

    case constants.UPDATE_PROMO_CODES_MODE: {
      let newState = state;
      if (action.mode !== state.getIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE])) {
        newState = newState
          .delete(constants.VALIDATION_ERRORS)
          .deleteIn([constants.DATA, constants.VALIDATION_PROMO_CODE_ERROR]);
      }
      newState = newState
        .setIn([constants.DATA, constants.PROMO_CODE_BULKS, constants.PROMO_CODE_MODE], action.mode);
      return newState;
    }


    default:
      return state;
  }
}

function transformCsvOrExcelDataToArray(value) {
  let membershipImportArray = [];
  if (value.includes(String.fromCharCode(13))) {
    membershipImportArray = value.split(String.fromCharCode(13)).map((item) => item.trim());
  } else if (value.includes(',')) {
    membershipImportArray = value.split(',').map((item) => item.trim());
  } else if (value.includes(String.fromCharCode(32))) {
    membershipImportArray = value.split(String.fromCharCode(32)).map((item) => item.trim());
  } else if (value.includes('\n')) {
    membershipImportArray = value.split('\n').map((item) => item.trim());
  } else if (value.includes(String.fromCharCode(9))) {
    membershipImportArray = value.split(String.fromCharCode(9)).map((item) => item.trim());
  } else {
    membershipImportArray.push(value.trim());
  }
  return membershipImportArray.filter((key) => !_.isEmpty(key));
}
